const rules = {
  title: 'Rule Management',
  subheadings: {
    rules: 'Rules',
    rulesets: 'Rulesets',
    violations: 'Violations',
  },
  helpers: {
    search_active_violations: 'Search Active Violations',
    search_inactive_violations: 'Search Inactive Violations',
    select_prompt: 'Select an instruction to view or edit',
    max_reached: 'Maximum of 10 instructions reached',
    instructions_helper:
      'Add up to 10 custom instructions for drivers to view when arriving at the property',
    instruction_title_helper: 'Maximum 64 characters',
    instruction_text_helper: 'Maximum 254 characters',
  },
  labels: {
    active_violations: 'Active Violations',
    inactive_violations: 'Inactive Violations',
    included_rules: 'Included Rules',
    excluded_rules: 'Excluded Rules',
    filezone: 'Drop photo here or click to browse',
    patrol_schedule: 'Patrol Schedule',
    enforcement_schedule: 'Enforcement Schedule',
    tow_rule_details: 'Tow Rule Details',
    tag_rule_details: 'Tag Rule Details',
    patrol_rule_details: 'Patrol Rule Details',
  },
  buttons: {
    add_to_schedule: 'Add To Schedule',
    end_date: 'Add Expiration Date',
    disable_violation: 'Disable Violation',
    delete_violation: 'Delete Violation',
  },
  dialogs: {
    violation_in_use_title: 'Violation In Use',
    violation_in_use_summary_delete:
      'Deleting the violation "{{name}}" will remove it from all of the following rules:',
    violation_in_use_summary_disable:
      'Disabling the violation "{{name}}" will prevent it from being enforced on all of the following rules:',
  },
};

export default rules;
